import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {interval, Subscription} from 'rxjs';

@Component({
    selector: 'app-maintenance-modal',
    templateUrl: './maintenance-modal.component.html',
    styleUrls: ['./maintenance-modal.component.scss'],
    standalone: false
})
export class MaintenanceModalComponent implements OnInit, OnDestroy {
  @Input() endDate: Date;

  public timeRemaining = '';
  private timerSubscription: Subscription;

  ngOnInit(): void {
    this.startCountdown();
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  private startCountdown(): void {
    this.updateTimeRemaining();

    this.timerSubscription = interval(1000).subscribe(() => {
      this.updateTimeRemaining();
    });
  }

  private updateTimeRemaining(): void {
    if (!this.endDate) {
      this.timeRemaining = 'Unknown';
      return;
    }

    const now = new Date();
    const endDateTime = new Date(this.endDate);
    const timeLeft = endDateTime.getTime() - now.getTime();

    if (timeLeft <= 0) {
      this.timeRemaining = 'Maintenance should be complete';
      if (this.timerSubscription) {
        this.timerSubscription.unsubscribe();
      }
      return;
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    let result = '';

    if (days > 0) {
      result += `${days}d `;
    }

    result += `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    this.timeRemaining = result;
  }

}
